import React, { FunctionComponent } from 'react';

import { Card } from '@savgroup-front-common/core/atoms/Cards';
import { Heading } from '@savgroup-front-common/core/atoms/Heading';
import { Datatable } from '@savgroup-front-common/core/components/Datatable';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { MessageType } from '@savgroup-front-common/types';

import SHORTCUTS_COLUMNS from '../../ShortcutsContent.config';
import { ShortcutKey } from '../../ShortcutsContent.types';

import { $ShortcutTableContainer } from './ShortcutTable.styles';

interface ShortcutTableProps {
  title: MessageType;
  withoutMarginBottom?: boolean;
  data: ShortcutKey[];
}

const ShortcutTable: FunctionComponent<
  React.PropsWithChildren<ShortcutTableProps>
> = ({ data, title, withoutMarginBottom = false }) => {
  return (
    <Card
      minimal
      withBorder
      withoutPaddingBottom
      withoutMarginBottom={withoutMarginBottom}
    >
      <Heading level={3}>
        <SafeFormattedMessageWithoutSpread message={title} />
      </Heading>
      <$ShortcutTableContainer>
        <Datatable<ShortcutKey>
          hits={data}
          columns={SHORTCUTS_COLUMNS}
          dataTestId="shortcutTable"
        />
      </$ShortcutTableContainer>
    </Card>
  );
};

ShortcutTable.displayName = 'ShortcutTable';

export default ShortcutTable;
